import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import About from "./Components/About/About";
import Services from "./Components/Services/Services";
import Portfolio from "./Components/Portfolio/Portfolio";
import Contact from "./Components/Contact/Contact";
import Blog from "./Components/Blog/Blog";
import { Helmet } from "react-helmet";

function App() {
  return (
    <Router>
      <Navbar />
      <Helmet>
        <title>Interior Design</title>
        <meta
          name="description"
          content="Discover the best interior design ideas and services for transforming your home or office. Our team provides creative and tailored solutions to enhance your space."
        />
        <meta
          name="keywords"
          content="Interior Design, Home Decor, Office Design, Interior Solutions, Best Interior Designers, Creative Interiors, Space Transformation"
        />
        <meta name="author" content="Interior Design Experts" />
        <meta property="og:title" content="Interior Design" />
        <meta
          property="og:description"
          content="Explore top-notch interior design services, offering personalized solutions for your home and office spaces."
        />
      </Helmet>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
